const JsIasIsotope = {
	init () {

		/*
		* Isotope Layout
		*/

		var $grid;

		// Masonry - using metafizzy's Isotope to handle it, we have more options than desandro should we wish to modify anything.
		// Weight is comparable.
		if ( $('.isotope-grid').length ) {
			$grid = $('.isotope-grid').isotope({
				// main isotope options
				itemSelector: '.isotope-item',
				percentPosition: true,
				// set layoutMode
				layoutMode: 'masonry',
				// options for masonry layout mode
				masonry: {
					columnWidth: '.isotope-item',
					horizontalOrder: true
				}
			})

			// setTimeout(() => {
			// 	$('.isotope-grid').isotope('layout');
			// }, 500);
		}

		/*
		 * Infinite Scroll
		*/
		if ( $('.ias').length ) {
			// IAS definition, re-used globally
			var Ias = $.ias({
				container:  '.ias',
				item:       '.ias-item',
				pagination: '.ias-pagination',
				next:       '.ias-next'
			});

			Ias.extension(new IASSpinnerExtension()); // shows a spinner (a.k.a. loader)

			// We need to check if it's ga or en
			let url = window.location.href;
			var pathArray = window.location.pathname.split( '/' );

			if ( pathArray[1] == "ga" ) {
				Ias.extension(new IASTriggerExtension({offset: 1, html: '<div class="row small-collapse ias-load-more"><div class="columns small-12"><button class="ias-trigger ias-trigger-next e-button-load-more">Níos Mó</button></div></div></div>'})); // shows a trigger after page 3
			} else {
				Ias.extension(new IASTriggerExtension({offset: 1, html: '<div class="row small-collapse ias-load-more"><div class="columns small-12"><button class="ias-trigger ias-trigger-next e-button-load-more">Load More</button></div></div></div>'})); // shows a trigger after page 3
			}

			Ias.extension(new IASNoneLeftExtension({ html: '<div class="row"><div class="columns small-12 hide">No more items to load</div></div>'})); // override text when no pages left

			// Setting the items to 0 opacity while rendering creates a nice loading in effect
			Ias.on('render', function(items) {
				$(items).css({ opacity: 0 });
			});

			// Once IAS has rendered, we need to run a whole lot of js to get the cards working again
			Ias.on('rendered', function(items) {
				$(document).foundation();
				Foundation.reInit('equalizer');

				$grid.isotope( 'appended', items );
				$grid.isotope( 'layout' );

				if ( $('.ias').find('.fitvid').length ) {
          if ( $('.deferred-video').length > 0 ) {

            $('.deferred-video').each( function(key, value) {

              if ( $(value).data('src') ) {

                let targetSrc = $(value).data('src');
                $(value).attr('src', targetSrc);
              }

            });
          }

					$('.fitvid').fitVids();
					$grid.isotope( 'layout' );
				}

				if( $('.ias').find('.c-card-slider').length ) {

					// Calculate whether or not card images should have portrait override class
					// first loop through all sliders on page
					$('.ias').find('.c-card-slider').find('.c-slide').each( function(key, value) {
						// Find actual image
						let targetImage = $(value).find('img');

						// Create test image, to compare dimensions
						let testImage = new Image();
						testImage.src = targetImage.attr('src');

						let imgWidth = testImage.naturalWidth;
						let imgHeight = testImage.naturalHeight;

						if ( imgHeight !== 0 ) {
							if ( imgHeight >= imgWidth ) {
								$(value).find('img').addClass('portrait');
							}
						}
					});

					// Init Slider
					$('.ias').find('.c-card-slider').not('.slick-initialized').slick({
						// Lazyload all the things
						lazyLoad: 'ondemand',
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: true,
						prevArrow: '<div class="slick-prev" aria-hidden="true"><div>',
						nextArrow: '<div class="slick-next" aria-hidden="true"><div>',
						dots: false,
						draggable: true,
						pauseOnFocus: false,
						pauseOnHover: false,
						fade: true,
						infinite: true,
						cssEase: 'linear'
					});
				}

				if ( $('.ias').find('.c-gallery').length ) {
					$('.ias').find('.c-gallery').lightGallery({
						selector: '.gallery',
						thumbnail: true,
						// showThumbByDefault: false
					});
                }
			});

			Ias.on('noneLeft', function() {
				$('.ias').addClass('none-left');
			});
		}

	}
};

export default JsIasIsotope;



// WEBPACK FOOTER //
// ./src/js/modules/ias-isotope.js